/* eslint no-mixed-operators: 0 */
/* eslint eqeqeq: 0 */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import Modal from '../Modal';
import SignUpForm from '../SignUpForm';
import { uploadStart, uploadFinish } from '../../reducers/uploadReducer';
import * as userReducer from '../../reducers/userReducer';
import * as modal from '../../reducers/modalReducer';
import * as page from '../../reducers/pageReducer';
import { membershipUri } from '../../config/uri';
import { isSmallViewPortWidth } from '../../helpers/display_util';
import { signUp } from '../../actions/login';
import * as addressReducer from '../../reducers/addressReducer';
import { getConfigValue } from '../../reducers/configReducer';
import {
  setDeliveryAddresses, setPickupAddresses, setDelivery, setPickup,
} from '../../reducers/addressReducer';
import {
  CUSTOMER_TYPE_ALLOW, AGREEMENT_ADULT_USE, AGREEMENT_MEDICAL_USE, DEFAULT_PATIENT_TYPE, AGE_RESTRICTION,
} from '../../config/const';
import {
  isMembershipAgreement as isMembershipAgreementSelector, getSecondaryColor, isTaxByPackageCustomerType, isProductsByCustomerTypeEnabled, isHowDidYouHearAboutUsEnabled, isEmailVerificationRequired,
} from '../../selectors/configSelectors';
import { getDateWithStartOfDayInUTCStringify, setTimeZone } from '../../helpers/date';
import ScrollableDatePicker from '../ScrollableDatePicker';
import { enableScrollJs, disableScrollJs } from '../../helpers/scroll';
import CustomerType from '../../const/customer_type';
import { openSmallModal } from '../../actions/modal';
import CustomerTypeMismatchModelContent from '../CustomerTypeMismatchModelContent/customer_type_mismatch_model_content_container';
import { isProductInCartAndCustomerTypeMismatch } from '../../helpers/customer_type_helper';
import { getCurrentCustomerType } from '../../selectors/customer_type_selector';
import SmallModal from '../SmallModal/small_modal_container';
import { getHoldProductCustomerTypes } from '../../selectors/hold_product_selectors';
import { resetHoldProduct } from '../../reducers/holdProductReducer';
import ConfirmModal from '../ConfirmModal/ConfirmModal';
import EmailValidationModal from '../EmailValidationModal/EmailValidationModal';
import {DUPLICATE_USER, INVALID_EMAIL_ADDRESS, UNKNOWN_EMAIL_ADDRESS} from '../../const/email_const';
import { startRequestCode } from '../../actions/signup-sync';
import {pushWithQueryParams} from "../../services/uri";
import {INVALID_CAPTCHA_TOKEN, INVALID_CAPTCHA_TOKEN_MESSAGE} from '../../const/captcha_const';
import {isFailResultCode} from "../../helpers/api";

const DEFAULT_ADULT_AGE = 21;
const VALID = 'VALID';
class SignUpFormModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      values: undefined,
      handleSubmitClick: false,
      customerType: this.getCustomerType(),
      isDatePickerOpen: false,
      externalSelectedDate: undefined,
      emailStatus: VALID,
      isEmailCorrect: false,
      currentEmail: undefined,
    };
  }

    getAgeRestriction = () => {
      try {
        const ageRestrictionObj = JSON.parse(this.props.ageRestrictions);

        if (this.state.customerType === CustomerType.MEDICAL) {
          return ageRestrictionObj.MEDICAL;
        }

        return ageRestrictionObj.ADULT;
      } catch (e) {
        console.error(e);
        return DEFAULT_ADULT_AGE;
      }
    }

    getMaxDate = () => {
      const maxDate = new Date();

      maxDate.setFullYear(maxDate.getFullYear() - this.getAgeRestriction());
      maxDate.setHours(0);
      maxDate.setMinutes(0);
      maxDate.setSeconds(0);
      return maxDate;
    }

    getMinDate = () => {
      const minDate = new Date();
      minDate.setFullYear(1900);
      return minDate;
    }

    getCustomerType = () => {
      if (this.props.customerTypeAllowed === CustomerType.ALL) {
        return this.props.defaultPatientType === 'ADULTUSE' ? CustomerType.ADULT : this.props.defaultPatientType;
      }
      return this.props.customerTypeAllowed;
    }

    customerTypeChange = (customerType, callback) => {
      this.setState({ customerType }, callback);
    }

    onCloseRequest = () => {
      if (!this.state.handleSubmitClick) {
        this.props.hideModal();
      }
    }

    showAgreement = () => {
      const { isMembershipAgreement } = this.props;
      if (!isMembershipAgreement) {
        return;
      }

      return this.state.customerType === 'ADULT' && this.props.agreementAdultUse == 1
        || this.state.customerType === 'MEDICAL' && this.props.agreementMedicalUse == 1;
    }

    getInitialValues = () => (this.props.signUpFormValues ? this.props.signUpFormValues : undefined)

    getSelectedCustomerType() {
      const {
        customerType,
      } = this.state;

      return customerType;
    }

    buildSignUp(data) {
      return {
        email: data.email,
        phone: data.phone.replace(/-/g, ''),
        firstName: data.name,
        lastName: data.lastname,
        addresses: this.props.deliveryAddresses.map(a => a.address),
        birthday: getDateWithStartOfDayInUTCStringify(data.birthday),
        customerType: this.state.customerType,
        emailCorrect: this.state.isEmailCorrect,
        userCaptchaResponseToken: data.userCaptchaResponseToken,
      }
    }


    buildTempUser(data) {
      return {
        id: data.id,
        firstName: data.name,
        lastName: data.lastname,
        customerType: data.customerType,
        rewardPoints: data.rewardPoints,
        rewardTier: data.rewardTier,
        isRec: false,
        isID: false,
        isFetched: true
      }
    }

    handleFailedSignup(reason, data) {
      switch (reason) {
        case INVALID_EMAIL_ADDRESS:
        case UNKNOWN_EMAIL_ADDRESS:
          this.setState({
            emailStatus: reason,
            currentEmail: data.email,
          });
          return;
        case DUPLICATE_USER:
          return 'EMAIL ADDRESS OR PHONE NUMBER ARE ALREADY IN USE.';
        case INVALID_CAPTCHA_TOKEN:
          return INVALID_CAPTCHA_TOKEN_MESSAGE;
      }
    }

    handleSignUp(values) {

      this.setState({
        handleSubmitClick: true,
        values,
      }, async () => {
        let data = undefined;

        this.props.uploadStart();

        try {
          data = (await signUp(this.buildSignUp(values))).data
          if (isFailResultCode(data)){
            this.handleFailedSignup(data.resultReason, values)
            this.props.uploadFinish();
            return;
          }
        } catch (error) {
          let messageError = this.handleFailedSignup(error.response.data.resultReason, values)
          this.props.openSignUpErrorModal(values, messageError);
          this.props.uploadFinish();
          return;
        }
        this.props.uploadFinish();

        this.props.setTempUser(this.buildTempUser(data));

        const pickAddresses = data.pickupAddresses.map(addr => ({dispensaryName: addr.name, address: addr}));
        this.props.setPickupAddresses(pickAddresses);

        this.props.hideModal();
        this.props.hidePage();

          if (this.showAgreement()) {
            this.props.openMembershipPage();
          } else if (this.props.isHowDidYouHearAboutUsEnabled) {
            this.props.openHowDidYouHear();
          } else if (this.props.isEmailVerification) {
            this.props.openSignUpConfirm();
          } else {
            this.props.requestCode();
          }
        })
      }

    setCustomerMismatchAndSaveFormValues(formValues) {
      this.setState({ isCustomerTypeMismatch: true, values: formValues });
    }

    handleSubmit = (values) => {
      const {
        holdProductCustomerTypes,
        isTaxByPackageCustomerType,
        isProductsByCustomerTypeEnabled,
      } = this.props;

      const {
        customerType,
      } = this.state;

      const mismatch = isProductsByCustomerTypeEnabled && isProductInCartAndCustomerTypeMismatch(
        customerType,
        holdProductCustomerTypes,
        isTaxByPackageCustomerType,
      );

      if (mismatch) {
        this.setCustomerMismatchAndSaveFormValues(values);
      } else {
        this.handleSignUp(values);
      }
    }

    renderPicker({ isDatePickerOpen } = this.state) {
      const closeHandler = () => this.setState({ isDatePickerOpen: false });

      return (
        <ScrollableDatePicker
          color={`#${this.props.secondaryColor}`}
          isOpen={isDatePickerOpen}
          onCancel={closeHandler}
          onSelect={(date) => {
            this.setState({ externalSelectedDate: setTimeZone(date) });
            enableScrollJs();
            closeHandler();
          }}
          max={this.getMaxDate()}
          min={this.getMinDate()}
        />
      );
    }

  openExternalDatePicker = () => {
    disableScrollJs();
    this.setState({ isDatePickerOpen: true });
  }


  resetProductOnHoldAndContinueSignUp(formValues) {
    const {
      resetOnHoldProduct,
    } = this.props;

    resetOnHoldProduct();
    this.handleSignUp(formValues);
  }

  confirmEmailValidation = () => {
    const { emailStatus, values } = this.state;

    if (emailStatus === INVALID_EMAIL_ADDRESS) {
      this.setState({
        emailStatus: VALID,
      });
    } else if (emailStatus === UNKNOWN_EMAIL_ADDRESS) {
      this.setState({
        isEmailCorrect: true,
        emailStatus: VALID,
      }, () => {
        this.handleSignUp(values);
      });
    }
  }

  cancelEmailValidation = () => {
    this.setState({
      emailStatus: VALID,
    });
  }

  render() {
    const {
      emailStatus,
      isCustomerTypeMismatch,
      values,
      customerType,
      externalSelectedDate,
    } = this.state;

    const {
      currentCustomerType,
      hideModal,
    } = this.props;

    return (
      <React.Fragment>
        <Modal
          style={{ display: !isCustomerTypeMismatch ? '' : 'none' }}
          id="signupformmodal"
          overlayTop={0}
          closeOnOverlayClick
          closeOnOutsideClick={false}
          isOpened
          onClose={this.onCloseRequest}
          scrollable={isSmallViewPortWidth()}
        >
          <SignUpForm
            initialValues={this.getInitialValues()}
            customerType={customerType}
            onCloseRequest={this.onCloseRequest}
            onSubmit={this.handleSubmit}
            customerTypeChange={this.customerTypeChange}
            externalSelectedDate={externalSelectedDate}
            openDatePicker={this.openExternalDatePicker}
            maxDate={this.getMaxDate()}
            ageRestriction={this.getAgeRestriction()}
          />
          {this.renderPicker()}
        </Modal>
        {isCustomerTypeMismatch && (
          <SmallModal
            content={(
              <CustomerTypeMismatchModelContent
                onOk={() => this.resetProductOnHoldAndContinueSignUp(values)}
                onCancel={() => {
                  hideModal();
                }}
                currentCustomerType={currentCustomerType}
              />
            )}
          />
        )}
        {emailStatus !== 'VALID' && (
          <EmailValidationModal
            isEmailVerification={this.props.isEmailVerification}
            emailStatus={emailStatus}
            email={this.state.currentEmail}
            confirm={this.confirmEmailValidation}
            cancel={this.cancelEmailValidation}
          />
        )}
      </React.Fragment>
    );
  }
}

SignUpFormModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  deliveryAddresses: PropTypes.arrayOf({}).isRequired,
  resetOnHoldProduct: PropTypes.func.isRequired,
  currentCustomerType: PropTypes.string.isRequired,
  holdProductCustomerTypes: PropTypes.string.isRequired,
  isTaxByPackageCustomerType: PropTypes.bool.isRequired,
  isProductsByCustomerTypeEnabled: PropTypes.bool.isRequired,
  setPickupAddresses: PropTypes.func.isRequired,
  setDeliveryAddresses: PropTypes.func.isRequired,
  isEmailVerification: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  deliveryAddresses: addressReducer.getDeliveryAddresses(state),
  agreementAdultUse: getConfigValue(AGREEMENT_ADULT_USE, state),
  agreementMedicalUse: getConfigValue(AGREEMENT_MEDICAL_USE, state),
  defaultPatientType: getConfigValue(DEFAULT_PATIENT_TYPE, state).toUpperCase(),
  customerTypeAllowed: getConfigValue(CUSTOMER_TYPE_ALLOW, state),
  isMembershipAgreement: isMembershipAgreementSelector(state),
  ageRestrictions: getConfigValue(AGE_RESTRICTION, state),
  secondaryColor: getSecondaryColor(state),
  currentCustomerType: getCurrentCustomerType(state),
  holdProductCustomerTypes: getHoldProductCustomerTypes(state),
  isTaxByPackageCustomerType: isTaxByPackageCustomerType(state),
  isProductsByCustomerTypeEnabled: isProductsByCustomerTypeEnabled(state),
  isHowDidYouHearAboutUsEnabled: isHowDidYouHearAboutUsEnabled(state),
  isEmailVerification: isEmailVerificationRequired(state),
});

const mapDispatchToProps = dispatch => ({
  openSignUpErrorModal: (signUpFormValues, errorMessage) => dispatch(modal.openModal({
    modalType: 'SIGN_UP_ERROR',
    modalProps: { signUpFormValues, errorMessage },
  })),
  openHowDidYouHear: props => dispatch(modal.openModal({
    modalType: 'HOW_DID_YOU_HEAR',
    modalProps: {},
  })),
  openSignUpConfirm: props => dispatch(modal.openModal({
    modalType: 'SIGNUP_CONFIRM_FORM',
    modalProps: {},
  })),
  setDeliveryAddresses: addresses => dispatch(setDeliveryAddresses(addresses)),
  setPickupAddresses: addresses => dispatch(setPickupAddresses(addresses)),
  setDelivery: addressId => dispatch(setDelivery(addressId)),
  setPickup: addressId => dispatch(setPickup(addressId)),
  openMembershipPage: () => dispatch(pushWithQueryParams(membershipUri)),
  hidePage: () => dispatch(page.hidePage()),
  hideModal: () => dispatch(modal.hideModal()),
  setTempUser: user => dispatch(userReducer.setTempUser(user)),
  uploadStart: () => dispatch(uploadStart()),
  uploadFinish: () => dispatch(uploadFinish()),
  showModal: props => dispatch(openSmallModal(props)),
  resetOnHoldProduct: () => dispatch(resetHoldProduct()),
  requestCode: () => dispatch(startRequestCode()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUpFormModal);



// WEBPACK FOOTER //
// ./src/components/SignUpFormModal/SignUpFormModal.jsx